import React from 'react';
import { Switcher } from 'ctia-ui';

const Toggler = ({ ...args }) => <Switcher {...args} />;

export default Toggler;
